import { mdiClose } from '@mdi/js'
import Icon from '@mdi/react'

const Close = (props) => (
    <Icon data-testid="IconButton__Close" path={mdiClose} size={1} {...props} />
)

export default Close
